import { useQuery } from '@tanstack/react-query';
import { fetchAllCountriesList } from '../data-provider/country-list';

export const useGetCountryList = () => {
  return useQuery({
    queryKey: ['all-country-list'],
    queryFn: () => fetchAllCountriesList(),
    staleTime: Number.POSITIVE_INFINITY, // loaded only once
  });
};
